import { useState, useCallback } from "react"

// Adapted from https://usehooks.com/useLocalStorage
/**
 * @template T
 * @param {string} key
 * @param {T} initialValue
 * @returns {[T, (value: T) => void]}
 */
export function useLocalStorage(key, initialValue) {
  const [storedValue, setStoredValue] = useState(() => {
    try {
      const item = window.localStorage.getItem(key)
      return item
        ? JSON.parse(item)
        : initialValue instanceof Function
          ? initialValue()
          : initialValue
    } catch (_error) {
      return initialValue
    }
  })

  const setValue = useCallback(
    (value) => {
      try {
        const valueToStore =
          value instanceof Function ? value(storedValue) : value
        setStoredValue(valueToStore)
        window.localStorage.setItem(key, JSON.stringify(valueToStore))
      } catch (error) {
        console.log(error)
      }
    },
    [key, storedValue],
  )

  return [storedValue, setValue]
}

export const removeLocalStorageValue = (key) => {
  try {
    if (typeof window !== "undefined") {
      window.localStorage.removeItem(key)
    }
  } catch (error) {
    console.log(error)
  }
}
